import { Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { type IWithIsMobile } from "../../../../legacy/interfaces/IWithIsMobile.interface";

const DEFAULT_LAYOUT_CONTENT_MOBILE_PADDING = `${Spacing["2000"]} ${Spacing["1000"]} ${Spacing["8000"]} ${Spacing["1000"]}`;
const DEFAULT_LAYOUT_CONTENT_DESKTOP_PADDING = `${Spacing["2500"]} ${Spacing["8000"]} ${Spacing["4000"]} ${Spacing["8000"]}`;

function shouldForwardProp(prop: string) {
  return prop !== "isMobile";
}

export const DefaultLayoutContentContainer = styled(Box, { shouldForwardProp })<IWithIsMobile>(({ isMobile }) => ({
  padding: isMobile ? DEFAULT_LAYOUT_CONTENT_MOBILE_PADDING : DEFAULT_LAYOUT_CONTENT_DESKTOP_PADDING,
}));
